export default __webpack_public_path__ + "static/media/sign-in.ddfc7d0b.svg";